export default __webpack_public_path__ + "static/media/speaker.0de65d75.png";